import Requester from "./svc";
import { getRecentHistory } from "../history/actions";
import { handleSnackBar, handleTopRightInfo, invokePostService } from "../global/actions";
import config from "../../config";
import types from "./actionTypes";
import auth from "../auth/actions";
import { updateFullInstances, resetInstances } from '../constructs/bootloaders/actions';
import { updateFullClusterlets, resetClusterlets } from '../constructs/clusterlets/actions';
import { updateFullClusterletConnections, resetClusterletConnections } from '../constructs/clusterlet_connections/actions';
import { updateFullEvents, resetEvents } from '../constructs/events/actions';
import { updateFullFields, replaceFullFields } from '../constructs/fields/actions';
import { updateFullHandlers, resetHandlers } from '../constructs/handlers/actions';
import { updateFullMessages, resetMessages } from '../constructs/messages/actions';
import { updateFullNetworks, resetNetworks } from '../constructs/networks/actions';
import { updateFullRoutingRules, resetRoutingRules } from '../constructs/routing_rules/actions';
import { updateFullSections, replaceFullSections } from '../constructs/sections/actions';
import { updateFullTransactions, resetTransactions } from '../constructs/transactions/actions';
import { updateFullUserTriggers, resetUserTriggers } from '../constructs/user_triggers/actions';
import { updateUtilityFunctions, resetUtilityFunctions } from '../constructs/utility_functions/actions';
import { updateFullTemplate, resetTemplate } from '../constructs/templated_clusterlet/actions'
import { updateUndo } from '../undoredo/actions';
import { updateRedo } from '../undoredo/actions';
import { setLoadingFalse } from '../global/actions';
import { updateBlueprintSlugDetails, setAppMode } from '../global/actions';
import { setBuildLoader, setDeployLoader, handleLogs, setSavingInProgress, handleBottomTerminal } from './../global/actions';
import { resetUndoRedo } from '../undoredo/actions'
import { findClusterletPositionsForImportedBp } from "../../services/reactFlowService";
// import { updateCompleteSchema, updateCompleteCode } from '../views/actions';
import { updateCompleteViews, updateFullView, resetView } from '../views/actions';
import { getDuplicates, removeDuplicates, checkDuplicateNonEmpty, checkParentId } from '../../services/entities/common';
import { controlDelegate, controlDelegateInstance } from '../../config/control_delegate';
import { getAppMode } from '../global/selectors';
import { createConnection } from '../../services/entities/connections';
import { createDelegate } from '../../services/entities/delegate';
import { addClusterletConnection } from '../constructs/clusterlet_connections/actions';
import { findAbsolutePosition, toInstanceData, findRelativePosition } from '../../services/reactFlowService';
import { addInstance } from "../constructs/bootloaders/actions";
import { getNetworks, networkForDelegate } from "../constructs/networks/selectors";
import { getDigitalTwins, getConstructs } from "../constructs/clusterlets/selectors";
import { addNetwork } from "../constructs/networks/actions";
import { onDrop, addClusterlet } from '../constructs/clusterlets/actions';
import { sanitizeEventAttributes } from '../../services/entities/event';
import { setBlueprintDataToLocalStorage, checkBPViewsEqual, checkBPConstructsEqual, getLastUpdateTimeFromLocalStorage, setLastUpdateTimeToLocalStorage, removeLastUpdatedTime } from '../../services/blueprint';
import { setCurrentViewId } from '../global/actions';
import { resetBlueprintConstructs } from '../constructs/clusterlets/actions';


const short = require("short-uuid");
const util = require('util')
const log = console.log;
const fetch = new Requester();

export const resetBluePrint = () => ({ type: types.RESET_BLUEPRINT });


export const read = (folderName, editRequest = false, forceunlock = false) => async (dispatch, getState) => {

	try {

		const docid = folderName.split("-").slice(-1);
		const ticketFromLocalStorage = localStorage.getItem(`mode_${docid}`);

		let url = ticketFromLocalStorage !== null ? `${fetch.route.read}?ticket=${ticketFromLocalStorage}&forceunlock=${forceunlock}` : fetch.route.read + `?forceunlock=${forceunlock}`;

		// let receivedBlueprint = await fetch.post(url, { folderName });
		// if (receivedBlueprint.status == false) {
		// 	dispatch(handleSnackBar({ open: true, message: receivedBlueprint.message, severity: "error" }));
		// 	return receivedBlueprint;
		// }
		// const checkPId = checkParentId(receivedBlueprint.blueprint.constructs);
		// const duplicateData = { ...checkPId, ...receivedBlueprint.blueprint.views }


		// // const duplicateData = { ...receivedBlueprint.blueprint.constructs, ...receivedBlueprint.blueprint.views }

		// const duplicates = getDuplicates(duplicateData);
		// const isDuplicateNonEmpty = checkDuplicateNonEmpty(duplicates);
		// setBlueprintDataToLocalStorage(receivedBlueprint.blueprint?.docId, receivedBlueprint.blueprint.constructs, receivedBlueprint.blueprint.views, receivedBlueprint.updatedAt);
		// if (isDuplicateNonEmpty) {
		// 	const sanitizedConstructs = removeDuplicates(duplicateData, duplicates);
		// 	const { views, ...constructData } = sanitizedConstructs;
		// 	const sanitized = {
		// 		...receivedBlueprint,
		// 		blueprint: {
		// 			...receivedBlueprint.blueprint,
		// 			constructs: constructData,
		// 			views: {
		// 				views: views
		// 			}
		// 		}
		// 	}


		// 	/**sanitize events to update onrecv and onsend handlers in event */
		// 	const constructs = sanitizeEventAttributes(sanitized.blueprint.constructs);
		// 	sanitized.blueprint.constructs = constructs;

		// 	dispatch(clearAll()).then(async res => {
		// 		dispatch(updateStateData(sanitized));
		// 	}).catch((error) => {
		// 		console.error('An error occurred:', error);
		// 	});




		// }
		// else {

		// 	/**sanitize events to update onrecv and onsend handlers in event */
		// 	const constructs = sanitizeEventAttributes(receivedBlueprint.blueprint.constructs);
		// 	receivedBlueprint.blueprint.constructs = constructs;

		// 	// dispatch(updateStateData(receivedBlueprint));
		// 	dispatch(clearAll()).then(async res => {
		// 		dispatch(updateStateData(receivedBlueprint));
		// 	}).catch((error) => {
		// 		console.error('An error occurred:', error);
		// 	});

		// }

		// /**on refresh set default view id*/
		// dispatch(setCurrentViewId(receivedBlueprint.blueprint.views.views.length > 0 ? receivedBlueprint.blueprint.views.views[0].id : null));

		// const appMode = getAppMode(getState());

		// if (receivedBlueprint.mode != appMode && appMode != 'edit') {
		// 	dispatch(handleSnackBar({ open: true, message: `Switched to edit mode`, severity: "success" }));
		// }
		// setReadWriteStatus(receivedBlueprint.blueprint, receivedBlueprint.mode, receivedBlueprint?.ticket, dispatch);




		dispatch(setLoadingFalse())
		// return receivedBlueprint;

	} catch (error) {

		console.log(error, 'error from READ')
		dispatch(handleSnackBar({ open: true, message: `${error}`, severity: "error" }));
		log(error, "[read]");
	}
};

const setReadWriteStatus = (blueprint, mode, ticket, dispatch) => {
	dispatch(setAppMode(mode));

	if (blueprint === undefined) {
		return false;
	}
	if (mode == 'edit') {
		localStorage.setItem(`mode_${blueprint.id}`, ticket);
	} else {
		localStorage.removeItem(`mode_${blueprint.id}`);
		dispatch(handleSnackBar({ open: true, message: "Blueprint opened in read-only mode", severity: "error", save: false }));
	}
}

export const importFromTemplate = (folderName, cloneBlueprintName) => async (dispatch) => {

	try {

		let response = await fetch.post(fetch.route.import, { folderName, cloneBlueprintName });

		/**calculate position of clusterlets */
		const clusterlets = JSON.parse(JSON.stringify(response.data.blueprint.constructs.clusterlets));
		const clusterletsWithPositions = await findClusterletPositionsForImportedBp({ clusterlets });
		response.data.blueprint.constructs.clusterlets = [...clusterletsWithPositions];

		return response;

	} catch (error) {
		// console.log(error, 'error from IMPORT')
		dispatch(handleSnackBar({ open: true, message: `${error}`, severity: "error" }));
	}
}

export const importFromTemplateBlueprint = (id, name, description) => async (dispatch) => {

	let response = await fetch.post(fetch.route.importTemplate, { id, name, description });
	setReadWriteStatus(response.data, response.mode, response.ticket, dispatch);
	return response;
}

export const save = ({ autoSave = true, ...rest }) => async (dispatch, getState) => {

	try {

		let constructs = { constructs: getState().constructs }
		let global = { global: getState().global }
		let views = { views: getState().schema }
		//is in view mode ?
		const appMode = getAppMode(getState());
		if (global.global?.details?.docid === null && global.global?.details?.title === '') {
			if (rest?.callback && typeof rest.callback == 'function') {
				rest.callback();
			}

			return;
		}
		if (appMode == 'view') {

			//manually clicked on save or added some changes in the data
			if (autoSave == false || rest?.stateChangeListener) {
				dispatch(handleSnackBar({ open: true, message: process.env.REACT_APP_SAVE_DISABLED_MESSAGE, severity: "warning", save: false }));
			}

			if (rest?.callback && typeof rest.callback == 'function') {
				rest.callback();
			}

			return;
		}
		if (autoSave == false) {
			dispatch(handleSnackBar({ open: true, message: 'Saving blueprint...', severity: 'info', save: false }));
		}

		const isConstructsEqual = checkBPConstructsEqual(global.global?.details?.docid, constructs.constructs);

		const isViewsEqual = checkBPViewsEqual(global.global?.details?.docid, views);

		if (global.global?.details?.docid !== null && isConstructsEqual === true && isViewsEqual === true) {
			dispatch(setSavingInProgress(false));
			if (rest?.isExit !== true) {
				if (autoSave == false) {
					dispatch(handleSnackBar({ open: true, message: 'Nothing to save', severity: 'warning', save: false }));
				}

			}
			if (rest?.callback && typeof rest.callback === "function") {
				rest.callback();
			}
			return;
		}
		if (getState().global.savingInProgress === true) {
			if (rest?.callback && typeof rest.callback === 'function') {
				rest.callback({ slug: json.data.slug, id: json.data.id });
			}
			return;
		};


		dispatch(setSavingInProgress(true))


		let payload = {}
		let undoredoData = { undoredo: getState().undoredo };

		let newPayload = {
			builder: Object.assign(payload, undoredoData),
			constructs: constructs.constructs,
			global: global.global,
			views: views
		}

		newPayload.builder.isExit = (rest?.isExit === undefined ? false : true)
		const ticketFromLocalStorage = localStorage.getItem(`mode_${global.global?.details?.docid}`);
		const lastUpdate = getLastUpdateTimeFromLocalStorage(global.global?.details?.docid);
		if (global.global?.details?.docid !== null && (lastUpdate === undefined || lastUpdate === null)) {
			dispatch(setSavingInProgress(false));
			dispatch(handleSnackBar({ open: true, message: "Invalid data format. Please refresh the page", severity: "error", save: false }));
			if (rest?.callback && typeof rest.callback === "function") {
				rest.callback();
			}
			return;
		}
		let url = ticketFromLocalStorage !== null ? `${fetch.route.write}?ticket=${ticketFromLocalStorage}&lastUpdate=${lastUpdate}` : `${fetch.route.write}?lastUpdate=${lastUpdate}`;

		let json = await fetch.post(url, newPayload);
		if (json.status == true) {
			setBlueprintDataToLocalStorage(json.data?.id, constructs.constructs, views, json.updatedAt);
			if (autoSave == false) {
				dispatch(handleSnackBar({ open: true, message: "Blueprint saved", severity: "success", save: false }));
			}

			dispatch(updateBlueprintSlugDetails({ docid: json.data.id, _id: json.data._id, slug: json.data.slug }));

			if (json.data.undoRedo !== undefined) {
				//dispatch(updateUndo(json.data.undoRedo))
				//dispatch(updateRedo(json.data.undoRedo))
			}
			setReadWriteStatus(json.data, json.mode, json.ticket, dispatch);

			if (rest?.callback && typeof rest.callback === "function") {
				rest.callback({ slug: json.data.slug, id: json.data.id });
			}

			dispatch(setSavingInProgress(false))
			return { status: true };

		} else if (json.status == false) {

			dispatch(handleSnackBar({ open: true, message: process.env.REACT_APP_SAVE_DISABLED_MESSAGE, severity: "warning", save: false }));

			setReadWriteStatus(json.data, json.mode, json.ticket, dispatch);

			dispatch(setSavingInProgress(false))
			if (rest?.callback && typeof rest.callback === "function") {
				rest.callback();
			}


			return { ...json };
		}

	} catch (error) {
		dispatch(setSavingInProgress(false))
		log(error, "[save]");
		if (autoSave == false) {
			dispatch(handleSnackBar({ open: true, message: `Server not reachable2`, severity: "error" }));
		}
		return { status: false };
	}
};

export const onRefresh = () => (dispatch, getState) => {

	let params = window.location.pathname.split('/')
	const blueprintSlug = params[2];
	const currentId = getState().global.details.id;
	if (!currentId) {
		dispatch(read(blueprintSlug, false));
	}

};

export const onDelete = (selectedBlueprint) => async (dispatch) => {
	console.log("selectedBlueprint----", selectedBlueprint)

	let json = await fetch.delete(fetch.route.delete(selectedBlueprint));
	if (json.status) {
		dispatch(handleSnackBar({ open: true, message: "Blueprint is deleted!", severity: json.status ? "success" : "error" }));
	}
	else {
		dispatch(handleSnackBar({ open: true, message: json.message ? json.message : "Oops something went wrong!", severity: json.status ? "error" : "error" }));
	}
	dispatch(getRecentHistory());
};

export const onClone = (blueprintId, newBlueprintId, selectedBlueprint) => async (dispatch) => {

	let json = await fetch.get(fetch.route.clone(blueprintId, newBlueprintId, selectedBlueprint));
	if (json.status) {
		dispatch(handleSnackBar({ open: true, message: "Blueprint cloned successfully!", severity: json.status ? "success" : "error" }));
	}
	else {
		dispatch(handleSnackBar({ open: true, message: "Oops something went wrong!", severity: json.status ? "error" : "error" }));
	}
	dispatch(getRecentHistory());
};

export const onExport = (blueprintId, blueprintDetails) => async (dispatch) => {
	await fetch.export(fetch.route.export(blueprintId, blueprintDetails));
	dispatch(getRecentHistory());
};

export const exportBlueprintJson = (blueprintId, blueprintDetails) => async (dispatch) => {
	const response = await fetch.post(fetch.route.exportJson, { blueprintId, blueprintDetails });
	// const blueprintJson = JSON.stringify(response)
	return response;
}

export const downloadBlueprintZip =  (blueprintDetails, filePath) => async (dispatch) => {
	// console.log("downloadBlueprintZip-------------------", {blueprintDetails, filePath})

		fetch.copyBlueprintZip(fetch.route.downloadBlueprintJson, {filePath}, dispatch)
				.then(response => {
					if (!response.ok) {
						throw new Error('Network response was not ok');
					}

					return response.blob();
				}).then(blob => {
					// Create a URL for the downloaded file
					const url = URL.createObjectURL(blob);
		
					// Trigger a download prompt
					const link = document.createElement('a');
					link.href = url;
					link.download = `${blueprintDetails?.name}.zip`;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
		
					dispatch(handleSnackBar({ open: true, message: 'Blueprint exported', severity: "success" }));
					return {status: true, message: "Blueprint exported" }

				}).catch(error => {
					console.error('Error fetching zip file', error);
					// dispatch(handleSnackBar({ open: true, message: 'Blueprint export failed', severity: "error" }));
					return {status: false, message: "Blueprint export failed" }
				});
	


}


export const initEventStream = (options, isBuild) => async (dispatch, getState) => {
	let eventSource = null;
	try {

		const blueprintBuilder = getState().global
		// console.log('blueprintBuilder----->', blueprintBuilder)
		// const docid = blueprintBuilder.details.docid
		isBuild = isBuild || false;
		// const blueprintId = blueprintBuilder.details.id;

		let wUrl = window.location.pathname;
		let segments = wUrl.split('/')

		let blueprintId = segments[3] != undefined ? segments[3] : ''

		// const query = new URLSearchParams({ ...(options || {}), folderName: blueprintId, isBuild, docid }).toString();
		const query = new URLSearchParams({ ...(options || {}), isBuild, blueprintId }).toString();
		const url = config.apiUrl + "/event/deploy?" + query + `&authorization=${decodeURI(localStorage.getItem("token"))}`;
		eventSource = new EventSource(url);

		eventSource.addEventListener("error", (error) => {

			eventSource.close();
			dispatch(auth.logout(true, blueprintBuilder.details._id));
			dispatch(setBuildLoader({ status: false }))
			dispatch(setDeployLoader({ status: false }))
			dispatch(handleBottomTerminal(true, "Build Console"));
			dispatch(handleTopRightInfo({}))
		});

		eventSource.addEventListener("message", (message) => {

			dispatch(handleLogs(message.data));
			if (document.getElementById("bottamdiv")) document.getElementById("bottamdiv").scrollIntoView({ behavior: "smooth" });
		});

		eventSource.addEventListener("status", (message) => {

			let statusText = '';
			dispatch(setBuildLoader({ status: false }))
			dispatch(setDeployLoader({ status: false }))
			dispatch(handleBottomTerminal(true, "Build Console"));
			dispatch(handleTopRightInfo({}))
			if (message.data === 'invalid_login') {
				statusText = "[error]Invalid controller login. Please check your deployment configuration[/error]"
			}
			else
				statusText = message.data;
			dispatch(handleLogs(statusText));
			if (document.getElementById("bottamdiv")) document.getElementById("bottamdiv").scrollIntoView({ behavior: "smooth" });
		});

		eventSource.addEventListener("close", () => {
			eventSource.close();
			if (document.getElementById("bottamdiv")) document.getElementById("bottamdiv").scrollIntoView({ behavior: "smooth" });
			dispatch(setBuildLoader({ status: false }))
			dispatch(setDeployLoader({ status: false }))
			dispatch(handleBottomTerminal(true, "Build Console"));
			dispatch(handleTopRightInfo({}))
		});
	} catch (error) {
		eventSource.close();
		log(error, "[initEventStream]");
		console.log('build:error')
		dispatch(setBuildLoader({ status: false }))
		dispatch(setDeployLoader({ status: false }))
		dispatch(handleBottomTerminal(true, "Build Console"));
		dispatch(handleTopRightInfo({}))
	}
};

export const uploadCustomBlueprint = (payload, folderName) => async (dispatch) => {

	let response = await fetch.postFile(fetch.route.importCustom, payload, dispatch)

	/**calculate position of clusterlets */
	// const clusterlets = JSON.parse(JSON.stringify(response.data.blueprint.constructs.clusterlets));
	// const clusterletsWithPositions = await findClusterletPositionsForImportedBp({ clusterlets });
	// response.data.blueprint.constructs.clusterlets = [...clusterletsWithPositions];

	return response
}

export const uploadCustomBlueprintJson = (payload) => async (dispatch) => {
	let response = await fetch.postFile(fetch.route.importJson, payload, dispatch);
	return response;
}

export const updateStateData = (blueprintData) => async (dispatch) => {

	console.log('update state----->')
	if (blueprintData !== null) {

		if (blueprintData.undoRedo.undo !== undefined) dispatch(updateUndo(blueprintData.undoRedo.undo));
		if (blueprintData.undoRedo.redo !== undefined) dispatch(updateRedo(blueprintData.undoRedo.redo));

		await dispatch(updateBlueprintSlugDetails({
			id: blueprintData?.blueprint.name,
			title: blueprintData?.blueprint.name,
			slug: blueprintData?.blueprint.slug,
			description: blueprintData?.blueprint.description,
			docid: blueprintData?.blueprint.id,
			_id: blueprintData?.blueprint._id
		}));

		//check if there's a clusterlet
		let newClusterlets = [...blueprintData.blueprint.constructs.clusterlets];
		let newInstances = [...blueprintData.blueprint.constructs.bootloaders];
		const controllerDelegateWithInState = newClusterlets.find(c => c?.subType !== undefined);
		if (controllerDelegateWithInState == null || controllerDelegateWithInState === undefined) {
			newClusterlets = [controlDelegate, ...newClusterlets];
			newInstances = [controlDelegateInstance, ...newInstances];
		}

		dispatch(updateFullInstances(newInstances))
		dispatch(updateFullClusterlets(newClusterlets))
		dispatch(updateFullClusterletConnections(blueprintData.blueprint.constructs.clusterletConnections))
		dispatch(updateFullEvents(blueprintData.blueprint.constructs.events))
		dispatch(updateFullFields(blueprintData.blueprint.constructs.fields))
		dispatch(updateFullHandlers(blueprintData.blueprint.constructs.handlers))
		dispatch(updateFullMessages(blueprintData.blueprint.constructs.messages))
		dispatch(updateFullNetworks(blueprintData.blueprint.constructs.networks))
		dispatch(updateFullRoutingRules(blueprintData.blueprint.constructs.rrdefs))
		dispatch(updateFullSections(blueprintData.blueprint.constructs.sections))
		dispatch(updateFullTransactions(blueprintData.blueprint.constructs.transactions))
		dispatch(updateFullUserTriggers(blueprintData.blueprint.constructs.user_triggers))
		dispatch(updateUtilityFunctions(blueprintData.blueprint.constructs.utility_functions))
		dispatch(updateFullTemplate(blueprintData.blueprint.constructs.templated_clusterlet))

		if (blueprintData.blueprint?.views !== undefined && blueprintData.blueprint?.views !== null && Array.isArray(blueprintData.blueprint.views.views) === true) {
			dispatch(updateCompleteViews(blueprintData.blueprint?.views));
		}

	}

}



export const initiateRestore = (payload) => async (dispatch, getState) => {

	console.log('initiate restore------.', payload)

	// const payload = {
	// 	blueprintId,
	// 	date,
	// 	backupId
	// };
	const result = await fetch.post(fetch.route.initiateRestore, payload);


	if (!result?.status) {
		dispatch(handleSnackBar({ open: true, message: result?.message ? result?.message :'Could not restore the blueprint', severity: "error" }));
		return { status: false, error: 'Could not restore the blueprint' };
	}

	return result;

	// try {
	// 	const blueprintToUpdate = blueprintToRestore;
	// 	setReadWriteStatus(blueprintToUpdate.blueprint, mode, ticket, dispatch);
	// 	await dispatch(resetBluePrint());
	// 	// await dispatch(resetUndoRedo());
	// 	// await dispatch(resetView());
	// 	dispatch(clearAll()).then(async res => {
	// 		console.log('after the clear in restore action')
	// 		dispatch(setLoadingFalse());
	// 		dispatch(updateStateData(blueprintToUpdate));
	// 		dispatch(handleSnackBar({ open: true, message: "Blueprint restored!", severity: "success" }));
	// 		setBlueprintDataToLocalStorage(blueprintToRestore?.blueprint?.id, blueprintToRestore?.blueprint?.constructs, blueprintToRestore?.blueprint?.views, blueprintToRestore?.blueprint?.updatedAt);

	// 	}).catch((error) => {
	// 		console.error('An error occurred:', error);
	// 	});
	// 	return { status: status, blueprintData: { docId: blueprintToRestore?.blueprint.id, slug: blueprintToRestore?.blueprint?.slug } }


	// } catch (error) {
	// 	dispatch(handleSnackBar({ open: true, message: 'No data found for the requested version', severity: "error" }));
	// 	return { status: false, error: 'No data found for the requested version' }
	// }


}

export const deleteBackup = ({ blueprintId, backupIds }) => async (dispatch, getState) => {
	const payload = {
		blueprintId,
		backupIds
	};

	const { status, message } = await fetch.post(fetch.route.deleteBackup, payload);

	return { status, message }
}

export const singleBlueprintbackup = (backupData, backupLocation="S3", onMessageCallback, onErrorCallback) => async (dispatch, getState) => {
	let eventSource;
	try {

		const message = backupData.name;
		let segments = (window.location.pathname).split('/');
		let blueprintId = '';
		if (segments[3] === undefined || segments[3] === null) {
			return { status: false, message: "Blueprint not found" }
		}
		blueprintId = segments[3];

		let params = {bpId: blueprintId,blueprintId,message, backupLocation}
		eventSource = fetch.singleBlueprintBackup("singleBlueprintBackup", params);

		eventSource.onmessage = (event) => {
			onMessageCallback({data: event.data, backupItem: params});

			let message = JSON.parse(event.data)?.message
			if(message === "Backup completed" || message === "No changes from the last backup" || message === "Error on blueprint backup!" || message === "Invalid git configuration!"){
				eventSource?.close();
				console.log("--stream closed--")
			}
		};

		eventSource.onerror = (event) => {
			console.error("Error while backup",)
			onErrorCallback(event?.data);
			
			eventSource?.close();
			console.log("--stream closed--")
        };


	} catch (error) {
		console.error(`Error while creating backup. ${error}`);	
        eventSource?.close();	
	}

}


export const veifyDeployConfiguration = (payload) => async (dispatch, getState) => {

	try {
		let { status, error, data } = await fetch.post(fetch.route.verifyConfig, payload);
		if (status) {
			dispatch(handleSnackBar({ open: true, message: "Deployment configuration verified", severity: "success" }));
		} else {
			dispatch(handleSnackBar({ open: true, message: error, severity: "error" }));
		}
		return { status, error, data };

	} catch (error) {
		log(error, "[test]");
		return { status: false };
	}
};

export const getTemplates = (page, rowsPerPage) => async (dispatch, getState) => {
	try {
		let response = await fetch.post(fetch.route.getTemplates, { page, rowsPerPage });
		if (response.status === false) {
			dispatch(handleSnackBar({ open: true, message: "Failed to fetch the templates.", severity: "error" }));
			return { status: response.status, templates: response.templates }
		}

		return { status: response.status, templates: response.templates, recordCount: response.totalCount };

	}
	catch (error) {
		return { status: false };
	}

}

export const createTemplate = (templateData) => async (dispatch, getState) => {
	try {

		// const blueprintBuilder = getState().global;
		// const docid = blueprintBuilder.details.docid;
		// const blueprintId = blueprintBuilder.details.id;

		// const payload = {
		// 	blueprintId,
		// 	docid,
		// 	templateData
		// };


		const { status, message } = await fetch.postFile(fetch.route.createTemplate, templateData, dispatch);

		return { status, message }
	}
	catch (error) {

	}
}

export const updateConstructs = (constructs) => async (dispatch, getState) => {

	if (constructs !== null) {

		dispatch(resetInstances(constructs.bootloaders))
		dispatch(resetClusterlets(constructs.clusterlets))
		dispatch(resetClusterletConnections(constructs.clusterletConnections))
		dispatch(resetEvents(constructs.events))
		dispatch(replaceFullFields(constructs.fields))
		dispatch(resetHandlers(constructs.handlers))
		dispatch(resetMessages(constructs.messages))
		dispatch(resetNetworks(constructs.networks))
		dispatch(resetRoutingRules(constructs.rrdefs))
		dispatch(replaceFullSections(constructs.sections))
		dispatch(resetTransactions(constructs.transactions))
		dispatch(resetUserTriggers(constructs.user_triggers))
		dispatch(resetUtilityFunctions(constructs.utility_functions))
		dispatch(resetTemplate(constructs.templated_clusterlet))

	}
}

export const addAssociation = (delegateId, newNode, data) => async (dispatch, getState) => {

	// const networks = getNetworks(getState());
	// const clusterlets = getClusterlets(getState());
	// const constructs = getConstructs(getState())

	// console.log('global dta', { clusterlets, constructs })

	// return


	// let delegateNode = {};
	// let connectedEntities = {};

	// if (delegate != 'create') {
	// 	delegateNode = clusterlets.find(c => c.id == delegateId);
	// 	const connection = createConnection(delegateNode, newNode, 'left', 'right');
	// 	dispatch(addClusterletConnection(connection, false, {}));
	// 	connectedEntities.connection = connection;

	// }
	// else {
	// 	delegateNode = createDelegate(`${data.name}_GW`, `${data.name} Gateway`, data.type, data.network);
	// 	const delegateInfo = { ...delegateNode }
	// 	const instanceData = toInstanceData(delegateInfo);
	// 	dispatch(addInstance(instanceData, true));
	// 	connectedEntities.instance = instanceData;

	// 	const connection = createConnection(delegateNode, newNode, 'left', 'right');
	// 	dispatch(addClusterletConnection(connection, false, {}));
	// 	connectedEntities.connection = connection;

	// 	const { networkExists, network: networkObj } = networkForDelegate({ editedDelegate: delegateNode, constructs });
	// 	if (!networkExists) dispatch(addNetwork(networkObj, true));
	// 	connectedEntities.network = networkObj;

	// 	delegate.attributes.network = networkObj.id
	// 	dispatch(addClusterlet(delegate, true));

	// }

	// return { delegateNode, connectedEntities }

}

export const releaseBlueprint = (blueprintToRelease) => (dispatch, getState) => {

	const blueprint = getState().global;
	const docid = blueprintToRelease ? blueprintToRelease.docid : blueprint.details.docid;
	const ticket = localStorage.getItem(`mode_${docid}`)
	fetch.get(`${fetch.route.releaseBlueprint}?ticket=${ticket}`);
	localStorage.removeItem(`mode_${docid}`);
	localStorage.removeItem(`constructs_${docid}`);
	removeLastUpdatedTime(docid);
	localStorage.removeItem(`views_${docid}`);
	console.log('end of releaseBlueprint...')
}

export const clearAll = () => (dispatch, getState) => {

	const viewPromise = new Promise(async (resolve, reject) => {
		console.log('Promise 1 View')
		await dispatch(resetView())
		resolve(true)
	});

	const constructsPromise = new Promise(async (resolve, reject) => {
		console.log('Promise 2 Constructs')
		await dispatch(resetBlueprintConstructs());
		resolve(true);
	})

	const undoRedoPromise = new Promise(async (resolve, reject) => {
		console.log('Promise 3 UndoRedo')
		await dispatch(resetUndoRedo());
		resolve();
	})

	return Promise.all([viewPromise, constructsPromise, undoRedoPromise]);

}

export const audit = () => async (dispatch, getState) => {

	try {
		const blueprintBuilder = getState().global;
		const docid = blueprintBuilder.details.docid;

		let auditResponse = await fetch.post(fetch.route.audit, { docId: docid });
		console.log('audit response ---->', auditResponse)

		if (auditResponse.validationErrors && auditResponse.validationErrors.length > 0) {
			return auditResponse
		}

	}
	catch (error) {

	}

}








